import { createGlobalStyle, css, FlattenSimpleInterpolation } from 'styled-components';

const CHECKMARK_SVG_HEADER =
  "%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E";
const CHECKMARK_SVG_PATH =
  "%3Cpath d='M9.85098 16.8645L5.50098 12.647" +
  'L6.19698 11.929L9.84098 15.461' +
  'L17.8015 7.50049L18.5085 8.20749' +
  "L9.85098 16.8645Z' fill='white' stroke='white' stroke-width='1'/%3E%3C/svg%3E";
const CHECKMARK_ICON_URL = `url("data:image/svg+xml,${CHECKMARK_SVG_HEADER}${CHECKMARK_SVG_PATH}")`;

const antSelectNotDisabled =
  ':not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer)';

export const SiteFilterGlobalStyles = createGlobalStyle`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    && .site-filter-trigger {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
    }

    && .site-filter__empty-label {
      position: absolute;
      left: ${kcc.spacing.MD};
      right: calc(${kcc.spacing.MD} + ${kcc.control.INTERACTIVE_SIZE}px + ${kcc.spacing.XXS});
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }

    && .site-filter-trigger:has(.ant-select-focused) .site-filter__empty-label {
      display: none;
    }

    && .site-filter.ant-select {
      height: ${kcc.control.HEIGHT}px;
      width: 100%;

      .ant-select-selector {
        height: ${kcc.control.HEIGHT}px;
        min-height: ${kcc.control.HEIGHT}px;
        padding: 0 calc(${kcc.spacing.MD} + ${kcc.control.INTERACTIVE_SIZE}px + ${kcc.spacing.XXS}) 0 ${kcc.spacing.MD};
        border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BLACK};
        border-radius: ${kcc.borderRadius.INPUT}px;
        background: transparent;
        box-shadow: none;
        display: flex;
        align-items: center;
      }

      .ant-select-selection-overflow {
        display: flex;
        flex: 1;
        flex-wrap: nowrap;
        align-items: center;
        align-self: stretch;
      }

      .ant-select-selection-overflow-item,
      .ant-select-selection-overflow-item-rest {
        display: flex;
        align-items: center;
      }

      &:not(.ant-select-open) {
        .ant-select-selection-search {
          width: 0 !important;
          overflow: hidden;
        }
      }

      &.ant-select-open {
        .ant-select-selection-overflow-item-rest {
          display: none;
        }

        .ant-select-selection-overflow-item-suffix {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          margin-inline-start: 0 !important;
        }

        .ant-select-selection-search {
          width: 100% !important;
          margin-inline-start: 0 !important;
        }
      }

      .ant-select-selection-search input {
        font-size: ${kcc.typography.FONT_SIZE.LG}px;
        width: 100% !important;
      }

      .ant-select-selection-item {
        background: transparent;
        border: none;
        padding: 0;
        line-height: normal;
        margin: 0;
        border-radius: 0;
        display: flex;
        align-items: center;
      }

      .ant-select-suffix,
      .ant-select-arrow {
        color: ${kcc.colors.TEXT};

        .site-filter__suffix-icon {
          width: ${kcc.control.INTERACTIVE_SIZE}px;
          height: ${kcc.control.INTERACTIVE_SIZE}px;

          svg {
            width: ${kcc.control.INTERACTIVE_SIZE}px;
            height: ${kcc.control.INTERACTIVE_SIZE}px;

            path {
              fill: ${kcc.colors.TEXT};
            }
          }
        }
      }

      .ant-select-arrow {
        right: ${kcc.spacing.MD};
      }
    }

    && .site-filter.ant-select-outlined${antSelectNotDisabled}:hover .ant-select-selector {
      border-color: ${kcc.colors.BLACK};
      box-shadow: none;
    }

    && .site-filter.ant-select-outlined.ant-select-focused${antSelectNotDisabled} .ant-select-selector,
    && .site-filter.ant-select-outlined.ant-select-open${antSelectNotDisabled} .ant-select-selector,
    && .site-filter.ant-select:focus-within .ant-select-selector {
      outline: none;
      box-shadow: none;
    }

    && .site-filter.ant-select .ant-select-selector {
      outline: none;
    }

    && .site-filter__placeholder {
      font-size: ${kcc.typography.FONT_SIZE.LG}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.REGULAR};
      line-height: normal;
      color: ${kcc.colors.TEXT};
      white-space: nowrap;
    }

    && .site-filter-dropdown.ant-tree-select-dropdown {
      border-radius: ${kcc.borderRadius.MENUS}px;
      border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BORDER};
      width: 250px;
      padding: ${kcc.spacing.XS} ${kcc.spacing.XS} ${kcc.spacing.XS} ${kcc.spacing.MD};

      .ant-select-tree {
        padding: 0;
      }

      .ant-select-tree-treenode {
        display: flex;
        align-items: center;
        height: ${kcc.control.HEIGHT_SM}px;
        padding: 0 ${kcc.spacing.XS} 0 0;
        margin: 0;
      }

      .ant-select-tree-node-content-wrapper {
        display: flex;
        align-items: center;
        flex: 1;
        min-width: 0;
        padding: 0;
        line-height: normal;
        font-size: ${kcc.typography.FONT_SIZE.BASE}px;
        color: ${kcc.colors.TEXT};
        overflow: hidden;

        &:hover {
          background-color: transparent;
        }
      }

      .ant-select-tree-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      }

      .ant-select-tree-treenode.filter-node .ant-select-tree-title {
        color: inherit !important;
        font-weight: inherit !important;
      }

      .ant-select-tree-treenode-active .ant-select-tree-node-content-wrapper {
        background-color: transparent;
      }

      .ant-select-tree-switcher {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: ${kcc.control.INTERACTIVE_SIZE}px;
        margin-right: ${kcc.spacing.XS};

        svg {
          width: ${kcc.control.INTERACTIVE_SIZE}px;
          height: ${kcc.control.INTERACTIVE_SIZE}px;
          transition: transform 0.2s ease;
        }

        .site-filter__switcher-icon {
          display: flex;
        }

        &_close .site-filter__switcher-icon svg {
          transform: rotate(-90deg);
        }

        &_open .site-filter__switcher-icon svg {
          transform: rotate(0deg);
        }

        &:not(.ant-select-tree-switcher-noop):hover::before {
          background-color: transparent !important;
        }
      }

      .ant-select-tree-checkbox {
        flex-shrink: 0;
        margin-top: 0;
        margin-right: ${kcc.spacing.XS};
      }

      .ant-select-tree-checkbox-inner {
        width: ${kcc.control.INTERACTIVE_SIZE}px;
        height: ${kcc.control.INTERACTIVE_SIZE}px;
        border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.GRAY_500};
        border-radius: 0;
        box-sizing: border-box;
        background-color: transparent;
      }

      .ant-select-tree-checkbox:not(.ant-select-tree-checkbox-checked) .ant-select-tree-checkbox-inner,
      .ant-select-tree-checkbox:not(.ant-select-tree-checkbox-checked):hover .ant-select-tree-checkbox-inner {
        border-color: ${kcc.colors.GRAY_500};
      }

      .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
        width: ${kcc.control.INTERACTIVE_SIZE}px;
        height: ${kcc.control.INTERACTIVE_SIZE}px;
        background-color: ${kcc.colors.BLACK};
        background-image: ${CHECKMARK_ICON_URL};
        background-repeat: no-repeat;
        background-position: center;
        background-size: ${kcc.control.INTERACTIVE_SIZE}px ${kcc.control.INTERACTIVE_SIZE}px;
        border: none;
        border-radius: 0;
        box-sizing: border-box;

        &::after {
          display: none;
        }
      }

      .ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner {
        border-color: ${kcc.colors.GRAY_500};

        &::after {
          background-color: ${kcc.colors.BLACK};
        }
      }
    }

    && .site-filter-search {
      padding: 2px 2px 0;
    }

    && .site-filter__switcher-icon {
      width: ${kcc.control.INTERACTIVE_SIZE}px;
      height: ${kcc.control.INTERACTIVE_SIZE}px;

      svg {
        width: ${kcc.control.INTERACTIVE_SIZE}px;
        height: ${kcc.control.INTERACTIVE_SIZE}px;
      }
    }

    && .site-filter-search__input.ant-input-affix-wrapper {
      height: 36px;
      width: 100%;
      box-sizing: border-box;
      border-radius: ${kcc.borderRadius.INPUT}px;
      border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BORDER_SECONDARY};
      box-shadow: none;
      padding: 6px ${kcc.spacing.MD};

      input::placeholder {
        color: ${kcc.colors.TEXT_PLACEHOLDER};
      }

      &:focus,
      &:focus-within {
        border-color: ${kcc.colors.BLACK};
        box-shadow: none;
      }
    }

    && .site-filter-search__icon {
      color: ${kcc.colors.TEXT_PLACEHOLDER};
      font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    }
  `}
`;
